import React, { useState } from 'react'
import { Panel, Button, Radio, RadioGroup, Message, ControlLabel, Input, Checkbox } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { directorSecureApproveTerminateProject } from '../../redux/actions/endOfProject'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getRequiredData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { NOT_COMPLETE, RETRY_CONTACT_ADMIN } from '../../constants/msgText'
import classNames from 'classnames'

export default function EndOfProjectApproveWidget({ schema: _schema, isContractCenter, ...props }) {
  const { showCommandButton } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [sendToGranteeVal, setSendToGranteeVal] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      projectVersionId: projectId,
      value: data[formSchema.note.name],
      note: data[formSchema.note.name],
      approveType: data[formSchema.approveType?.name] || 0,
      sendToGrantee: data.approveType == 2 ? true : sendToGranteeVal,
      noteSendToGrantee: data?.note || '',
    }
    // console.log(request)
    setRequest(request)

    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      // let response = ''
      // if (request.approveType == 1) {
      //   // secure approve
      //   response = await directorSecureApproveTerminateProject(projectId, request)
      // } else {
      //   response = await directorApproveTerminateProject(projectId, request)
      // }

      const response = await directorSecureApproveTerminateProject(projectId, request)

      if (response.success) {
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        if (request.approveType == 1) {
          // redirect secure approve
          window.location.href = response.secureApprovalUri
        } else {
          // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        setIsError(response.error)
      }
    } catch (e) {
      console.log('e', e?.response)
      if (e?.response?.data?.errors?.message) {
        setIsError(e?.response?.data?.errors?.message)
      } else {
        setIsError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }
  console.log('formSchema ', formSchema.approverCommentList)
  return (
    <Panel shaded header={formSchema?.header} eventKey={2} collapsible defaultExpanded>
      {formSchema.approverCommentList && (
        <div>
          <p>ความเห็นของผู้มีอำนาจแสดงความเห็น</p>
          <br />
          {formSchema.approverCommentList.map((item, index) => (
            // console.log('item ', item)

            <div style={{ marginBottom: 10 }}>
              <Panel header={`${index + 1}. ${item?.employeeName}` || '-ไม่ระบุ-'} bordered>
                <p style={{ textIndent: 35 }}>{`- ${item?.descriptionSummary || ''}`}</p>
              </Panel>
            </div>
          ))}
          <br />
        </div>
      )}

      {formSchema?.note && (
        <>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema.note.validators) && 'required'
            )}
          >
            {formSchema.note.label}
          </ControlLabel>

          {!formSchema.approveType && (
            <Checkbox
              // disabled={showCommandButton}
              defaultChecked={formSchema?.sendToGrantee?.value || sendToGranteeVal}
              onChange={(_, checked, e) => {
                console.log('checked ', checked)
                setSendToGranteeVal(checked)
              }}
            >
              {formSchema?.sendToGrantee?.label}
            </Checkbox>
          )}

          <ErrorMessage error={errors[formSchema.note.name]} />
          <Input
            name={formSchema.note.name}
            inputRef={register(isValidators(formSchema.note.validators))}
            rows={3}
            placeholder={formSchema.note.hint}
            componentClass="textarea"
            defaultValue={formSchema.note.value}
            disabled={formSchema.disabled}
          />
        </>
        // <InputForm
        //   disabled={formSchema.disabled}
        //   schema={formSchema.note}
        //   rows={3}
        //   componentClass="textarea"
        //   register={register}
        //   Controller={Controller}
        //   control={control}
        //   errors={errors}
        //   setValue={setValue}
        //   clearErrors={clearErrors}
        // />
      )}

      {formSchema.approveType && !isContractCenter && (
        <>
          <br />
          <ErrorMessage error={errors[formSchema.approveType.name]} />
          <Controller
            key={formSchema.approveType.name}
            name={formSchema.approveType.name}
            control={control}
            rules={isValidators(formSchema.approveType.validators)}
            defaultValue={formSchema.approveType.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                >
                  {formSchema.approveType?.options?.map((item) => {
                    return (
                      <Radio value={item.value} disabled={formSchema.disabled}>
                        {item.label}{' '}
                      </Radio>
                    )
                  })}
                </RadioGroup>
              )
            }}
          />
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          {isError && (
            <Message
              style={{ marginBottom: 10 }}
              showIcon
              type="error"
              description={isError || formSchema.buttonText + NOT_COMPLETE + ' ' + RETRY_CONTACT_ADMIN}
            />
          )}

          <Button ripple appearance="ghost" onClick={handleSubmit(onSubmit)} disabled={isLoading}>
            {sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText}
          </Button>
        </>
      )}

      <ConfirmWidget
        size="sm"
        title={`ยืนยันการ${
          sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText
        }`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${
          sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText
        }`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
